export function deleteIfHas<T>(array: T[], element: T) {
  const index = array.indexOf(element);
  const deleted = index !== -1;
  if (deleted) {
    array.splice(index, 1);
  }
  return deleted;
}


export function deleteIfHasBy<T extends object>(
  array: T[],
  element: T,
  key: keyof T,
) {
  const index = array.findIndex((_element) => _element[key] === element[key]);
  const deleted = index !== -1;
  if (deleted) {
    array.splice(index, 1);
  }
  return deleted;
}
